import React, {useState, Fragment,useRef,useEffect } from 'react';
import styled from "styled-components";
import cx from "classnames";
import { Input, Typography } from "@mui/material";

export default (props) => { 
  const [scrollY, setScrollY] = useState(0);

  const { logoImgUrl,mobile } = props;

  const handleScroll = () => {
    const { pageYOffset } = window;
    setScrollY(pageYOffset);
  };
  const documentRef = useRef(document);
  useEffect(() => {
    documentRef.current.addEventListener("scroll", handleScroll);
  });


  return (
    <Fragment>
      <Header>
        <h1>{logoImgUrl && <a><img src={logoImgUrl} alt="로고" /></a>}</h1>
        <ul>
          {/* <li><a><Typography component="span" variant="subtext2">등록조회</Typography></a></li>
          <li><a><Typography component="span" variant="subtext2">호스트센터</Typography></a></li> */}
        </ul>
      </Header>
    </Fragment>
  )
}

const Header = styled.header`
  position:fixed;
  top:0;
  left:0;
  display:flex;
  height:60px;
  border-bottom:1px solid #efefef;
  width:100%;
  align-items: center;
  justify-content:space-between;
  padding:0 20px;
  z-index: 10;
  background: #fff;
  ul{display:flex}
  ul li:first-child:after{content:""; display:inline-block; width:1px; height:10px; background:#d9d9d9; margin:0 12px; }
  h1{width:100%;}
  a{
    max-height: 40px;
    width: 100%;
    max-width: 240px;
    position: relative;
    height: 40px;
    cursor:default;
    display:block;
  }
  a img{
    max-width: inherit;
    max-height: inherit;
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
  }
  @media (max-width:767px){
    a{
      max-width: 160px;
      max-height: 40px;
      width: inherit;
    }
  }
  
`;